import { Flex, Form, Select, Space, Typography } from 'antd';

import { SearchButtons } from '@app/components';
import { PREFIX } from '@app/constants';
import { useActualImplementation } from '@app/pages/Analytics/ActualImplementation/hooks';
import { ActualImplementationTable } from '@app/pages/Analytics/ActualImplementation/ui/ActualImplementationTable';
import { MONTHS, YEARS, DEFAULT_FILTERS_DATA } from '@app/pages/Analytics/data';
import { useReportEffects } from '@app/pages/Analytics/hooks';

import '@pages/Analytics/ActualImplementation/styles/ActualImplementation.desktop.scss';

const { Text } = Typography;
const { Item } = Form;

export const ActualImplementation = () => {
  const {
    handleReset,
    form,
    handleSubmitForm,
    tableData,
    handleSearchData,
    isLoading,
  } = useActualImplementation();
  useReportEffects({
    handleSearchData,
  });

  return (
    <div className={`${PREFIX}actual-implementation`}>
      <Form
        form={form}
        onFinish={handleSubmitForm}
        initialValues={DEFAULT_FILTERS_DATA}
      >
        <Space
          className="content-header-space"
          direction="vertical"
          size="large"
        >
          <Flex justify="space-between">
            <Space size="large" align="baseline">
              <Text strong>Период:</Text>
              <Item name="filterMonth">
                <Select
                  placeholder="Выбор месяца"
                  popupMatchSelectWidth={false}
                  options={MONTHS}
                  className="filters-select"
                />
              </Item>
              <Item name="filterYear">
                <Select
                  placeholder="Выбор года"
                  popupMatchSelectWidth={false}
                  options={YEARS}
                  className="filters-select"
                />
              </Item>
            </Space>
            <SearchButtons
              className="desktop-buttons"
              resetAll={handleReset}
              showData={form.submit}
            />
          </Flex>

          <ActualImplementationTable
            isLoading={isLoading}
            tableData={tableData}
          />
        </Space>
      </Form>
    </div>
  );
};
